export default (): string => document.location.hostname.split('.').slice(-2).join('.');